var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAlphaAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.25C7.41421 1.25 7.75 1.58579 7.75 2V20.1893L10.4697 17.4697C10.7626 17.1768 11.2374 17.1768 11.5303 17.4697C11.8232 17.7626 11.8232 18.2374 11.5303 18.5303L7.53033 22.5303C7.23744 22.8232 6.76256 22.8232 6.46967 22.5303L2.46967 18.5303C2.17678 18.2374 2.17678 17.7626 2.46967 17.4697C2.76256 17.1768 3.23744 17.1768 3.53033 17.4697L6.25 20.1893V2C6.25 1.58579 6.58579 1.25 7 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.25C18.3 1.25 18.5712 1.4288 18.6894 1.70456L21.6894 8.70456C21.8525 9.08528 21.6762 9.52619 21.2954 9.68936C20.9147 9.85253 20.4738 9.67616 20.3106 9.29544L19.5055 7.41667H16.4945L15.6894 9.29544C15.5262 9.67616 15.0853 9.85253 14.7046 9.68936C14.3238 9.52619 14.1475 9.08528 14.3106 8.70456L17.3106 1.70456C17.4288 1.4288 17.7 1.25 18 1.25ZM18.8626 5.91667L18 3.90394L17.1374 5.91667H18.8626Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.25C14.5858 14.25 14.25 14.5858 14.25 15C14.25 15.4142 14.5858 15.75 15 15.75H19.3693L14.4306 21.5119C14.2399 21.7343 14.1962 22.0473 14.3186 22.3134C14.441 22.5795 14.7071 22.75 15 22.75H21C21.4142 22.75 21.75 22.4142 21.75 22C21.75 21.5858 21.4142 21.25 21 21.25H16.6307L21.5694 15.4881C21.7601 15.2657 21.8038 14.9527 21.6814 14.6866C21.559 14.4205 21.2929 14.25 21 14.25H15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAlphaAsc);
export default __webpack_public_path__ + "static/media/sort-alpha-asc.90c4de5c4e01692334b898f10724e9d0.svg";
export { ForwardRef as ReactComponent };